export const STORAGE_KEY_LOCALE = "locale";
export const STORAGE_KEY_RECAPTCHA_V2_FAIL_DATE = "recaptchaV2FailDate";
export const SUPPORTED_LANGUAGES = ["ru", "kk"];

export const DEPT_IDS = {
  ALMATY_C: 935,
  NURSULTAN_C: 635,
  SHYMKENT_C: 949,
  AKMOLA: 923,
  AKTOBE: 924,
  ALMATY: 925,
  ATYRAU: 926,
  VKO: 934,
  ZHAMBYL: 928,
  ZKO: 927,
  KARAGANDA: 922,
  KOSTANAY: 921,
  KYZYLORDA: 929,
  MANGYSTAU: 930,
  PAVLODAR: 932,
  SKO: 933,
  TURKESTAN: 931,
};

export const STORAGE_KEY_USER_ROLES = "user-roles";

export const MESSAGE_TYPE_INBOX = "0";
export const MESSAGE_TYPE_SENT = "1";
export const MESSAGE_TYPE_NOTIFICATIONS = "2";

export const _2_TO_THE_POWER_20 = 1048576;

export const EXEC_PROD_STATUS_PROCESSING = 1;
export const EXEC_PROD_STATUS_REJECTED = 2;
export const EXEC_PROD_STATUS_RETURN = 3;
export const EXEC_PROD_STATUS_COMPLETED = 50;
export const EXEC_PROD_STATUS_SUSPENDED = 51;
export const EXEC_PROD_STATUS_DIRECTED = 52;
export const EXEC_PROD_STATUS_CANCELED = 53;

export const ID_INDIVIDUAL = 1;
export const ID_LEGAL_ENTITY = 2;

export const CABINET_BASE_URL = "/extperson/api/";

export const STATEMENT_STATUS_DRAFT = "1";
export const STATEMENT_STATUS_PROCESSING_LAWMAN = "2";
export const STATEMENT_STATUS_REJECTED_LAWMAN = "3";
export const STATEMENT_STATUS_GET_ORIGINAL = "4";
export const STATEMENT_STATUS_REJECTED = "5";
export const STATEMENT_STATUS_DUPLICATE = "6";
export const STATEMENT_STATUS_SUCCESS = "7";

export const ROLE_EXTERNALUSERS = "ROLE_EXTERNALUSERS";
export const ROLE_STORONA_IP_FIRST_LEADER = "ROLE_STORONA_IP_FIRST_LEADER";
export const ROLE_STORONA_IP = "ROLE_STORONA_IP";
export const ROLE_EMPLOYER = "ROLE_EMPLOYER";
export const ROLE_CLAIMANT = "ROLE_CLAIMANT";

export const UNDER_CONSIDERATION = "under_consideration";
export const TRANSFER_COLLECT_DECREE = "transfer_collect_decree";

export const FILTER_PERIOD_MONTHS = 3;
